import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useEquityFilter } from './useEquityFilter';

export const EquityFilter = ({ value, setFilters, equityOptions }) => {
  const { formSchema, onSubmit } = useEquityFilter({ setFilters });

  const selectedOption = equityOptions.find((i) => i.value === value) ?? equityOptions[0];

  return (
    <Formik
      initialValues={{ compensationOffersEquity: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="compensationOffersEquity"
          label="Offers equity"
          placeholder="Equity"
          size="small"
          component={FormSelect}
          options={equityOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

EquityFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  equityOptions: PropTypes.array.isRequired,
};

EquityFilter.defaultProps = {
  value: '',
};
